// validation functions will be here in this file

export const getLocalTimezone = () => {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return localTimeZone;
};
